export const convertFromUxLangToCss = (ux = '') =>
  ux.toLowerCase().replace('.', '_');

export const convertFromCssToUxLang = (css = '') =>
  css.toUpperCase().replace('_', '.');



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Typography/Utils.js